import { t } from '../../../strings/i18n';
export const getAccountType = (paymentMethodType, paymentMethodMedium) => {
    const accountType = {
        PINLESS_DEBIT_CARD: t('button.debitCard'),
        CREDIT_CARD: t('button.creditCard'),
        CHECKING: t('button.checking'),
        SAVINGS: t('button.savings')
    };
    if (paymentMethodMedium && paymentMethodMedium !== 'E_CHECK') {
        return accountType[paymentMethodMedium];
    }
    return accountType[paymentMethodType];
};
